import { httpClient } from "../http/httpClient";
import { CreditPartner } from "@/view/pages/Credit/useCreditController";

export async function getPartnersByLinkName(linkName: string): Promise<CreditPartner[]> {
  const { data } = await httpClient.get<CreditPartner[]>(
    `/self-hire/partners/${linkName}`,
  ).catch((error) => {
    throw error?.response?.data || error;
  });

  return data;
}